module.exports = __webpack_public_path__ + "img/asus-ux482.612842cb.jpg";